/* eslint-disable security/detect-object-injection */
/* eslint-disable no-param-reassign */
/* eslint-disable no-secrets/no-secrets */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, DropdownSelectField, Icon } from '@jutro/legacy/components';
import { useModal } from '@jutro/components';
import { Link } from '@jutro/router';
import styles from './DisposalSitesComponent.module.scss';
import metadata from './DisposalSitesComponent.metadata.json5';
import messages from './DisposalSitesComponent.messages';
import { TranslatorContext } from '@jutro/legacy/locale';

function DisposalSitesComponent(props) {

    const {
        updateWizardData,
        submissionVM,
        index,
        pathUpdated
    } = props;
    const translator = useContext(TranslatorContext);
    const { showConfirm } = useModal();
    const modelVM = _.get(submissionVM, pathUpdated)
    const viewModelService = useContext(ViewModelServiceContext);

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, indexd) => {
            if (event) {
                event.preventDefault();
            }

            const infoListPath = `lobData.envLin.coverables.envImpairmentCoverable.materialsWasteAndTransDTO.rawMaterialsDisposalsDTO.value[${index}].disposals`;

            const infoList = _.get(submissionVM, infoListPath);


            const itemToRemove = infoList[indexd];

            showConfirm({
                title: messages.removeInfo,
                message: messages.removeInfoDesc,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.yes,
                cancelButtonText: messages.no
            }).then((result) => {
                if (result === 'cancel') {
                    return _.noop();
                }

                _.remove(infoList, (item) => _.isEqual(item, itemToRemove));

                _.set(submissionVM, infoListPath, infoList);

                const newSubmissionVM = viewModelService.clone(submissionVM);

                updateWizardData(newSubmissionVM);

                return true;
            }, _.noop);
        }, [index, submissionVM, showConfirm, viewModelService, updateWizardData]);

    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, indexP, props) => {
            const { path } = props;

            if (path === 'disSitNum') {
                const value = item.disSitNum ? item.disSitNum : '';

                return (
                    <InputField
                        id={indexP + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.disSitNum = val;
                            handleValueChange(val, changedPath, indexP);
                        }}
                        value={value}
                        readOnly
                    />
                );
            }

            if (path === 'disAdd') {
                const value = item.disAdd ? item.disAdd : '';

                return (
                    <InputField
                        id={indexP + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.disAdd = val;
                            handleValueChange(val, changedPath, indexP);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'disCit') {
                const value = item.disCit ? item.disCit : '';

                return (
                    <InputField
                        id={indexP + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.disCit = val;
                            handleValueChange(val, changedPath, indexP);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'disPro') {
                const value = (item && item.disPro) ? item.disPro : undefined;

                const availableValuesPath = `lobData.envLin.coverables.envImpairmentCoverable.materialsWasteAndTransDTO.rawMaterialsDisposalsDTO.children[${index}].disposals.children[${indexP}].disPro.aspects.availableValues`


                const availableValues = _.get(submissionVM, availableValuesPath) ? _.get(submissionVM, availableValuesPath)
                    .map((typeCode) => ({
                        code: typeCode.code,
                        name: translator({
                            id: typeCode.name,
                            defaultMessage: typeCode.name
                        })
                    })) : [];

                return (
                    <DropdownSelectField
                        id={indexP + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.disPro = val;
                            handleValueChange(val, changedPath, indexP);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                );
            }

            if (path === 'disPosCod') {
                const value = item.disPosCod ? item.disPosCod : '';

                return (
                    <InputField
                        id={indexP + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.disPosCod = val;
                            handleValueChange(val, changedPath, indexP);
                        }}
                        value={value}
                    />
                );
            }
        }, [handleValueChange, index, submissionVM, translator])

    const removeAssignmentTableRow = useCallback(
        (item, indexP) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            (<Link
                onClick={(e) => removeAssignmentItem(e, indexP, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>)
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => {
        const infoListPath = `lobData.envLin.coverables.envImpairmentCoverable.materialsWasteAndTransDTO.rawMaterialsDisposalsDTO.value[${index}].disposals`;
        const infoList = _.sortBy(_.get(submissionVM, infoListPath) || [], 'disSitNum');

        return {
            '@field': {
                showOptional: false,
                showRequired: true
            },
            [`DisposalSitesTable`]: {
                data: infoList,
            }
        };
    }, [index, submissionVM]);


    const resolvers = {
        resolveCallbackMap: {
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (id, path) =>
            readViewModelValue(
                metadata.pageContent,
                _.get(submissionVM, pathUpdated),
                id,
                path,
                overrideProps
            ),
        [overrideProps, pathUpdated, submissionVM]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={modelVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

DisposalSitesComponent.propTypes = wizardProps;
export default withRouter(DisposalSitesComponent);
